import { Route, Routes } from "react-router-dom";
import NotFoundScreen from "screens/NotFoundScreen";
import ShipmentRefundCreateScreen from "screens/App/CRM/Payment/ShipmentRefund/ShipmentRefundCreateScreen";
import ShipmentRefundDetailScreen from "screens/App/CRM/Payment/ShipmentRefund/ShipmentRefundDetailScreen";
import ShipmentRefundEditScreen from "screens/App/CRM/Payment/ShipmentRefund/ShipmentRefundEditScreen";
import ShipmentRefundListScreen from "screens/App/CRM/Payment/ShipmentRefund/ShipmentRefundListScreen";

const ShipmentRefundRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<ShipmentRefundCreateScreen />} />
      <Route path=":id/detail" element={<ShipmentRefundDetailScreen />} />
      <Route path="list" element={<ShipmentRefundListScreen />} />
      <Route path=":id/edit" element={<ShipmentRefundEditScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default ShipmentRefundRouter;
